import { render, staticRenderFns } from "./ContactAvatar.vue?vue&type=template&id=6849a0ea"
import script from "./ContactAvatar.vue?vue&type=script&lang=js"
export * from "./ContactAvatar.vue?vue&type=script&lang=js"
import style0 from "./ContactAvatar.vue?vue&type=style&index=0&id=6849a0ea&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6849a0ea')) {
      api.createRecord('6849a0ea', component.options)
    } else {
      api.reload('6849a0ea', component.options)
    }
    module.hot.accept("./ContactAvatar.vue?vue&type=template&id=6849a0ea", function () {
      api.rerender('6849a0ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contact/ContactAvatar.vue"
export default component.exports